<script setup lang="ts">
const locales = useLocales()
const { data: workspace } = useWorkspaceSettings()
const { steps } = useWorkspaceOnboarding()
const visibleSteps = computed(() => steps.value.filter((step) => !step.hidden))

const { $api, $trackEvent } = useNuxtApp()
const { mutate: exitOnboarding } = useMutation({
  fetchFunction: async () => {
    $trackEvent("workspace_onboarding_exited")

    if (workspace.value?.onboarding_state.has_exited) {
      await navigateTo({ name: "dashboard" })
      return
    }

    await $api("/admin/v1/workspace/onboarding/exit", {
      method: "post",
    })

    await navigateTo({ name: "dashboard" })
  },
})
</script>
<template>
  <nav class="relative z-10 w-full bg-white shadow-md">
    <div
      class="mx-auto flex flex-row items-center justify-between px-4 py-2 sm:px-6 xl:px-8 xl:py-2.5"
    >
      <NuxtLink
        class="relative mr-8 flex shrink-0 flex-row items-center justify-start xl:mr-0"
        :class="{ 'xl:w-56': visibleSteps.length <= 5 }"
        @click="exitOnboarding"
      >
        <LogoSvg class="h-8" />
      </NuxtLink>
      <div class="hidden grow items-center md:flex xl:justify-center">
        <slot />
      </div>
      <div class="flex w-56 items-center gap-4">
        <LocaleSwitcher :locales />
        <FormButton variant="secondary" @click="exitOnboarding">
          {{ $t("onboarding.exit") }}
          <SvgoPikaClose class="ml-2 size-5" />
        </FormButton>
      </div>
    </div>
  </nav>
</template>
